/* ++++++++++ --------------- IMPORT --------------- ++++++++++ */
import contentData from 'data/contentquestions';



//contentType helper
const contentProperties = (content, index) => {
    switch (content.contentType) {
        case 'story':
            return ({
                background: content.story.backgroundImageURL,
                backgroundColor: content.story.backgroundColor,
                contentType: content.contentType,
                text: content.story.title,
                ctaText: !!content.story.ctaText ? content.story.ctaText : null,
                storySignature: `storySignature-${index}`,
                url: content.story.url
            });
        default:
            return({
                background: content.questionBased.backgroundImageURL,
                backgroundColor: content.questionBased.backgroundColor,
                answersType: content.questionBased.type,
                text: content.questionBased.title,
                answerSignature: `answerSignature-${index}`,
                answers: []
            })
    }
};

const userDataCollectionProperties = data => ({
    id: "udc-01",
    queuePosition: 2,
    type: "user_data_collection",
    contentSignature: "udc-01",
    contentProperties: {
        publisherName: data.publisherName.value,
        publisherPrivacyPolicyURL: data.publisherPrivacyPolicyURL.value,
        backgroundColor: data.backgroundColor.value,
        backgroundImageURL: data.backgroundImageURL,
        headline: data.headline.value,
        body: data.body.value
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// this will be used to gauge the amount of time a user has spent for a given event fired by tracking
export default (contentState, embedData) => {
    const random = embedData.contentOrder === 'random';
    // helper vars
    let transpiledObject ={};
    let resultObject = {};
    let data = {};
    // loop contents in state
    for (let [index, content] of Object.entries(contentState.contents)) {
        if (content.contentLive) {
            transpiledObject = JSON.parse(JSON.stringify(contentData.data[0]));
            transpiledObject.id = content.contentType + index;
            transpiledObject.queuePosition = index;
            transpiledObject.type = content.contentType;
            transpiledObject.contentSignature = `contentSignature-${index}`;
            transpiledObject.contentProperties = contentProperties(content, index);
            if(content.contentType !== 'story'){
                resultObject[transpiledObject.id] = { options: {}};
                const options = Object.entries(content.questionBased.options);
                const numOfOptions = options.length;
                let total = 0;
                for (let [optIndex, option] of options) {
                    const optionUUID = !!option.optionUUID ? option.optionUUID : optIndex;
                    let currentNumOfTimesChosen = total === 0 ? Math.floor(Math.random() * 40) + 1 : (100 - total) / (numOfOptions - 1);
                    total += currentNumOfTimesChosen;
                    transpiledObject.contentProperties.answers.push({
                        id: optionUUID,
                        text: option.text,
                        image: option.imageURL,
                        emoji: option.emoji,
                        position: option.position
                    });
                    total = 0;
                    resultObject[transpiledObject.id]['options'][optionUUID] = currentNumOfTimesChosen;
                    if (!!option.correctOption) resultObject[transpiledObject.id]['answerUUID'] = optionUUID;
                }
                transpiledObject.contentProperties.answers.sort((answer1, answer2) => answer1.position - answer2.position)
            }
            data[content.queuePosition] = transpiledObject;
        }
    }
    // return transpiled object
    // console.log('DATA', JSON.stringify(Object.values(data)));
    let embedcontent = random ? Object.values(data).sort((con1,con2) => 0.5 - Math.random()) : Object.values(data);
    return { mxQuestionData: JSON.stringify(embedcontent), mxResultData: JSON.stringify(resultObject), udcData: JSON.stringify(userDataCollectionProperties(contentState.addons.userDataCollection))};
};



